// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fAqd","badges":"styles_badges__3wwB0"};